import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
declare const google: any;

@Component({
  selector: 'app-google-places',
  templateUrl: './google-places.component.html',
  styleUrls: ['./google-places.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => GooglePlacesComponent ), multi: true }
  ]
})
export class GooglePlacesComponent implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor {
    @Input() adressType: string;
    @Input() required: boolean;
    @Input() controlDirty;

    @Output() setAddress: EventEmitter<any> = new EventEmitter();
    @ViewChild('addresstext') addresstext: any;
    innerValue: any = '';

    queryWait: boolean;
  initialized: boolean;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(data: SimpleChanges) {
        if (data.controlDirty) {
            if (this.controlDirty) {
                this.formGroup.controls.address1.markAsDirty();
            } else {
                this.formGroup.controls.address1.markAsPristine();
            }
        }

        if (data.required) {
            this.formGroup.controls.address1.setValidators(this.required ? [Validators.required] : []);
            this.formGroup.controls.address1.updateValueAndValidity();
        }
    }

    ngAfterViewInit() {
    }

    public formGroup: UntypedFormGroup = new UntypedFormGroup({
      address1: new UntypedFormControl([], [Validators.required]),
    });
  
    // get accessor
    get value(): any {
      return this.innerValue;
    }
  
    // set accessor including call the onchange callback
    set value(v: any) {
      if (v !== this.innerValue) {
          this.innerValue = v;
          this.onChange(v);
      }
    }
  
    onChange: any = () => {};
    onTouched: any = () => {};
  
    registerOnChange(fn) {
      this.onChange = fn;
    }

    onTyping() {
      if (!this.initialized) {
        setTimeout(() => {
          this.getPlaceAutocomplete();
        }, 1000);
        this.initialized = true;
      }
    }
  
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
  
    writeValue(val) {
      this.formGroup.controls['address1'].setValue(val, { emitEvent: false });
      this.formGroup.valueChanges
      // .pipe(
      // delay(0)
      // )
      .subscribe(values => {
      this.onTouched(true);
      this.onChange(values.address1);
      });
  
      if (val !== this.innerValue) {
      this.innerValue = val;
      }
    }

    private getPlaceAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
            {
                componentRestrictions: { country: 'US' },
                types: [this.adressType],      // 'establishment' / 'address' / 'geocode'
                fields: ['address_component', 'formatted_address']  // Avoid paying for data that you don't need by restricting the set of place fields that are returned to just the address components.
            });

        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            autocomplete.get
            const place = autocomplete.getPlace();
            this.invokeEvent(place);
        });
    }

    invokeEvent(place: Object) {
        this.setAddress.emit(place);
    }
}
